import React from 'react';
import { useSelector } from 'react-redux';
import SimplePopup from '../../../../shared/components/ui/popup/SimplePopup';
import HeaderPopup from '../../../../shared/components/ui/backdropPopup/headerPopup/HeaderPopup';
import FinalProjectTimer from '../finalProjectTimer/FinalProjectTimer';
import ContentsPopup from '../../../../shared/components/ui/popup/contentPopup/ContentPopup';
import ButtonsPopup from '../../../../shared/components/ui/popup/buttonsPopup/ButtonsPopup';
import classes from './FinalProjectPopup.module.css';

const FinalProjectPopup = ({ isSubmitted, presentationDate, submissionBox, onClose }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <SimplePopup close={onClose} dropClass={classes.SimplePopup} dropClassClose={classes.CloseIcon}>
            <div className={classes.Body}>
                <div className={classes.HeaderWrapper}>
                    <HeaderPopup />
                </div>
                <div className={classes.ContentArea}>
                    <ContentsPopup scrollDropClass={classes.ScrollWrapper} className={classes.PopupContent}>
                        <div className={classes.TextBlock}>
                            <p className={classes.Title}>{presentationDate ? texts.newForYou : texts.payAttention}</p>
                            <div className={classes.MessageBlock}>
                                <p className={classes.SubTitle}>{presentationDate ? texts.w : texts.systemIsOpenForSubmission}</p>
                                {!presentationDate && <p className={classes.AdditionalText}>{texts.contactCoordinatorForMoreInfo}</p>}
                            </div>
                        </div>
                        <div className={classes.TimerWrapper}>
                            <FinalProjectTimer isSubmitted={isSubmitted} presentationDate={presentationDate} submissionBox={submissionBox} isPopup={true} />
                        </div>
                    </ContentsPopup>
                </div>
                <ButtonsPopup className={classes.Footer}>
                    <button className={classes.PopupButton} onClick={onClose}>{texts.ok}</button>
                </ButtonsPopup>
            </div>
        </SimplePopup>
    );
};

export default FinalProjectPopup;
